import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";

export default function PromoStrip() {
  const [promos, setPromos] = useState([]);
  useEffect(() => { (async () => {
    try { const { data } = await api.get("/site/ads"); setPromos(data || []); } catch (_e) {}
  })(); }, []);
  if (promos.length === 0) return null;
  return (
    <section className="max-w-7xl mx-auto px-4 sm:px-6 mt-12">
      <div className="flex items-end justify-between mb-4">
        <h2 className="font-heading text-2xl sm:text-3xl font-semibold text-[var(--brand-accent)]">Deals you'll love</h2>
        <span className="text-sm text-slate-500 hidden sm:block">Limited-time offers, refreshed daily</span>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5 stagger">
        {promos.map((p) => (
          <Link
            data-testid={`promo-card-${p.id}`}
            key={p.id}
            to={p.link || "/"}
            className="group relative h-52 rounded-2xl overflow-hidden border border-slate-200 shadow-sm hover:shadow-xl hover:-translate-y-1 transition-all duration-300"
          >
            {p.image && <img src={p.image} alt={p.title} className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" />}
            <div className="absolute inset-0 bg-gradient-to-t from-[var(--brand-accent)]/85 via-[var(--brand-accent)]/40 to-transparent" />
            {p.badge && <span className="absolute top-3 left-3 text-[10px] uppercase tracking-[0.18em] bg-[var(--brand-secondary)] text-[#064e3b] px-2 py-1 rounded-full font-bold">{p.badge}</span>}
            <div className="absolute bottom-0 p-4 text-white">
              <div className="font-heading text-xl font-semibold leading-tight text-shadow-strong">{p.title}</div>
              <div className="text-sm text-white/90 mt-1">{p.subtitle}</div>
              <div className="mt-3 inline-flex items-center text-[var(--brand-secondary)] text-sm font-medium">{p.cta || "Explore"} →</div>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}
